module.exports = __webpack_public_path__ + "img/autotagging_1.2a0c34be.jpg";